// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.order-page {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.order-container {
    background-color:
        #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    padding: 30px;
    margin-bottom: 30px;
    width: 100%;
}

.order-title {
    font-family: "Rigidica Text Bold", sans-serif;
    color: #333;
    text-align: center;
    margin-bottom: 10px;
    font-size: 28px;
}

.order-number {
    text-align: center;
    font-family: "Rigidica Text Regular", sans-serif;
    color: #555;
    font-size: 16px;
    margin-bottom: 30px;
}

.order-content {
    display: flex;
    flex-wrap: wrap;
    gap: 30px;
}

.order-details-section,
.order-items-section {
    flex: 1 1;
    min-width: 300px;
}

h2 {
    font-family: "Rigidica Text Bold", sans-serif;
    color: #333;
    margin-bottom: 20px;
    font-size: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
}

h3 {
    font-family: "Rigidica Text Bold", sans-serif;
    color: #444;
    margin: 20px 0 10px;
    font-size: 18px;
}

.order-info {
    background-color:
        #f9f9f9;
    padding: 15px;
    border-radius: 6px;
    margin-bottom: 20px;
}

.order-info-item {
    display: flex;
    justify-content: space-between;
    font-family: "Rigidica Text Regular", sans-serif;
    margin-bottom: 8px;
    color: #555;
}

.order-info-item:last-child {
    margin-bottom: 0;
}

.shipping-address {
    background-color:
        #f9f9f9;
    padding: 15px;
    border-radius: 6px;
}

.shipping-address p {
    margin: 5px 0;
    font-family: "Rigidica Text Regular", sans-serif;
    color: #555;
}

.order-items-container {
    margin-bottom: 20px;
}

.order-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    border-bottom: 1px solid #eee;
}

.order-item:last-child {
    border-bottom: none;
}

.item-details {
    display: flex;
    flex-direction: column;
}

.item-name {
    font-family: "Rigidica Text Regular", sans-serif;
    font-weight: 500;
    color: #333;
    margin-bottom: 5px;
}

.item-quantity {
    font-family: "Rigidica Text Regular", sans-serif;
    color: #666;
    font-size: 14px;
}

.item-price {
    font-family: "Rigidica Text Regular", sans-serif;
    font-weight: 500;
    color: #333;
    min-width: 80px;
    text-align: right;
}

.order-summary {
    background-color:
        #f9f9f9;
    padding: 15px;
    border-radius: 6px;
}

.order-summary-item {
    display: flex;
    justify-content: space-between;
    font-family: "Rigidica Text Regular", sans-serif;
    color: #555;
    margin-bottom: 8px;
}

.order-summary-item.total {
    font-weight: bold;
    padding-top: 8px;
    margin-top: 8px;
    border-top: 1px solid #ddd;
    color: #333;
}

.back-to-home {
    display: block;
    text-align: center;
    margin-top: 30px;
    padding: 10px;
    background-color: #333;
    color: white;
    text-decoration: none;
    border-radius: 4px;
    transition: background-color 0.3s;
    font-family: "Rigidica Text Regular", sans-serif;
    font-size: 16px;
}

.back-to-home:hover {
    background-color: #555;
}

.order-container.error,
.order-container.loading {
    font-family: "Rigidica Text Regular", sans-serif;
    text-align: center;
    padding: 60px 20px;
}

.order-container.error h1 {
    color:
        #d9534f;
    margin-bottom: 20px;
}

.order-container.loading h1 {
    color: #333;
    margin-bottom: 20px;
}

.loading-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.8);
    z-index: 1;
}

.loading-box {
    text-align: center;
    font-size: 24px;
    color: #333;
    font-family: "Rigidica Text Light", sans-serif;
    padding: 20px 40px;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.loading-text {
    font-size: 20px;
}

/* Guest Order Form Styling */
.guest-form {
    max-width: 500px;
    margin: 0 auto;
}

.guest-form h1 {
    font-family: "Rigidica Text Bold", sans-serif;
    color: #333;
    text-align: center;
    margin-bottom: 15px;
}

.guest-form p {
    font-family: "Rigidica Text Regular", sans-serif;
    color: #555;
    text-align: center;
    margin-bottom: 20px;
}

.guest-order-form {
    width: 100%;
    margin-bottom: 20px;
}

.form-error {
    color:
        #ff0000;
    margin-bottom: 15px;
    text-align: center;
    font-size: 14px;
    font-family: "Rigidica Text Light", sans-serif;
}

.form-group {
    margin-bottom: 15px;
}

.form-group label {
    display: block;
    margin-bottom: 5px;
    font-family: "Rigidica Text Regular", sans-serif;
    color: #555;
}

.form-group input {
    width: 100%;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-family: "Rigidica Text Regular", sans-serif;
    outline: none;
}

.submit-button {
    width: 100%;
    background-color: #333;
    color: #fff;
    padding: 15px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-family: "Rigidica Text Regular", sans-serif;
    font-size: 16px;
    transition: background-color 0.3s;
}

.submit-button:hover {
    background-color: #555;
}

.order-login-suggestion {
    text-align: center;
    margin-top: 15px;
    font-size: 14px;
    font-family: "Rigidica Text Regular", sans-serif;
    color: #000 !important;
}

.order-login-suggestion a {
    color: #333;
    text-decoration: none;
}

.order-login-suggestion a:hover {
    text-decoration: underline;
}

/* CSS Media Queries */

@media (max-width: 599px) {
    .order-page {
        padding-top: 40px;
        padding-bottom: 20px;
    }

    .order-container {
        padding: 15px;
    }

    .order-title {
        font-size: 1.5rem;
        margin-bottom: 12px;
    }

    .order-number {
        font-size: 14px;
        margin-bottom: 20px;
    }

    .order-content {
        gap: 20px;
    }

    h2 {
        font-size: 18px;
        margin-bottom: 15px;
    }

    h3 {
        font-size: 16px;
    }

    .guest-form h1 {
        font-size: 1.5rem;
    }

    .guest-form p {
        font-size: 14px;
    }

    .form-group input {
        padding: 8px;
    }

    .submit-button {
        font-size: 15px;
    }

    .back-to-home {
        font-size: 14px;
    }

    .order-login-suggestion {
        font-size: 13px !important;
    }
}

@media (min-width: 600px) and (max-width: 767px) {
    .order-page {
        padding-top: 40px;
    }

    .order-container {
        padding: 20px;
    }

    .order-title {
        font-size: 1.6rem;
    }

    .order-content {
        gap: 25px;
    }

    .guest-form {
        max-width: 350px;
    }
}

@media (min-width: 768px) and (max-width: 1023px) {
    .order-page {
        padding-top: 50px;
    }

    .order-container {
        padding: 25px;
    }

    .order-title {
        font-size: 1.7rem;
        margin-bottom: 18px;
    }

    .order-content {
        gap: 25px;
    }

    .guest-form {
        max-width: 380px;
    }

    .submit-button {
        font-size: 16px;
    }
}

@media (min-width: 1024px) and (max-width: 1279px) {
    .order-page {
        padding-top: 60px;
    }

    .order-content {
        gap: 30px;
    }

    .order-title {
        font-size: 1.8rem;
        margin-bottom: 20px;
    }

    .guest-form {
        max-width: 400px;
    }

    .submit-button {
        font-size: 16px;
    }

    .form-group {
        margin-bottom: 18px;
    }
}

@media (min-width: 1280px) and (max-width: 1439px) {
    .order-page {
        padding-top: 70px;
    }

    .order-title {
        font-size: 1.9rem;
        margin-bottom: 22px;
    }

    .guest-form {
        max-width: 420px;
    }

    .form-group {
        margin-bottom: 20px;
    }

    .form-group input {
        padding: 11px;
    }

    .submit-button {
        font-size: 17px;
    }
}

@media (min-width: 1440px) and (max-width: 1535px) {
    .order-page {
        padding-top: 80px;
    }

    .order-title {
        font-size: 2rem;
        margin-bottom: 24px;
    }

    .guest-form {
        max-width: 440px;
    }

    .form-group {
        margin-bottom: 22px;
    }

    .form-group input {
        padding: 12px;
    }

    .submit-button {
        font-size: 17px;
    }

    .form-error {
        font-size: 15px;
    }

    .order-login-suggestion {
        font-size: 15px !important;
    }
}

@media (min-width: 1536px) and (max-width: 1919px) {
    .order-page {
        padding-top: 90px;
    }

    .order-title {
        font-size: 2.1rem;
        margin-bottom: 26px;
    }

    .guest-form {
        max-width: 460px;
    }

    .form-group {
        margin-bottom: 24px;
    }

    .form-group input {
        padding: 13px;
        font-size: 16px;
    }

    .submit-button {
        font-size: 18px;
    }

    .order-login-suggestion {
        font-size: 16px !important;
    }
}

@media (min-width: 1920px) and (max-width: 2559px) {
    .order-page {
        padding-top: 40px;
    }

    .order-container {
        padding: 35px;
    }

    .order-title {
        font-size: 2.3rem;
        margin-bottom: 30px;
    }

    .guest-form {
        max-width: 500px;
    }

    .guest-form h1 {
        font-size: 2.2rem;
        margin-bottom: 20px;
    }

    .guest-form p {
        font-size: 18px;
        margin-bottom: 25px;
    }

    .form-group {
        margin-bottom: 26px;
    }

    .form-group label {
        font-size: 16px;
        margin-bottom: 8px;
    }

    .form-group input {
        padding: 14px;
        font-size: 16px;
        border-radius: 6px;
    }

    .submit-button {
        font-size: 19px;
        border-radius: 6px;
    }

    .back-to-home {
        font-size: 18px;
        margin-top: 40px;
    }

    .order-login-suggestion {
        font-size: 17px !important;
    }
}

@media (min-width: 2560px) {
    .order-page {
        padding-top: 120px;
    }

    .order-container {
        padding: 40px;
        border-radius: 10px;
    }

    .order-title {
        font-size: 2.5rem;
        margin-bottom: 35px;
    }

    .order-number {
        font-size: 18px;
        margin-bottom: 40px;
    }

    .order-content {
        gap: 40px;
    }

    h2 {
        font-size: 24px;
        margin-bottom: 25px;
    }

    h3 {
        font-size: 22px;
        margin: 25px 0 15px;
    }

    .guest-form {
        max-width: 550px;
    }

    .guest-form h1 {
        font-size: 2.5rem;
        margin-bottom: 25px;
    }

    .guest-form p {
        font-size: 20px;
        margin-bottom: 30px;
    }

    .form-group {
        margin-bottom: 30px;
    }

    .form-group label {
        font-size: 18px;
        margin-bottom: 10px;
    }

    .form-group input {
        padding: 16px;
        font-size: 18px;
        border-radius: 8px;
    }

    .submit-button {
        font-size: 20px;
        border-radius: 8px;
    }

    .back-to-home {
        font-size: 20px;
        margin-top: 50px;
        border-radius: 8px;
    }

    .form-error {
        font-size: 16px;
        margin-bottom: 20px;
    }

    .order-login-suggestion {
        font-size: 18px !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/OrderConfirmedPage.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI;eACW;IACX,kBAAkB;IAClB,0CAA0C;IAC1C,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,6CAA6C;IAC7C,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,gDAAgD;IAChD,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;AACb;;AAEA;;IAEI,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,6CAA6C;IAC7C,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,6CAA6C;IAC7C,WAAW;IACX,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI;eACW;IACX,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gDAAgD;IAChD,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;eACW;IACX,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gDAAgD;IAChD,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,gDAAgD;IAChD,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,gDAAgD;IAChD,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;eACW;IACX,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gDAAgD;IAChD,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,0BAA0B;IAC1B,WAAW;AACf;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,iCAAiC;IACjC,gDAAgD;IAChD,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;IAEI,gDAAgD;IAChD,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI;eACW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,0CAA0C;IAC1C,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,8CAA8C;IAC9C,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,eAAe;AACnB;;AAEA,6BAA6B;AAC7B;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,6CAA6C;IAC7C,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gDAAgD;IAChD,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI;eACW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,8CAA8C;AAClD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gDAAgD;IAChD,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,gDAAgD;IAChD,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gDAAgD;IAChD,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gDAAgD;IAChD,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,sBAAsB;;AAEtB;IACI;QACI,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":[".order-page {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 20px;\n    margin-top: 20px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.order-container {\n    background-color:\n        #ffffff;\n    border-radius: 8px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n    padding: 30px;\n    margin-bottom: 30px;\n    width: 100%;\n}\n\n.order-title {\n    font-family: \"Rigidica Text Bold\", sans-serif;\n    color: #333;\n    text-align: center;\n    margin-bottom: 10px;\n    font-size: 28px;\n}\n\n.order-number {\n    text-align: center;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    color: #555;\n    font-size: 16px;\n    margin-bottom: 30px;\n}\n\n.order-content {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 30px;\n}\n\n.order-details-section,\n.order-items-section {\n    flex: 1;\n    min-width: 300px;\n}\n\nh2 {\n    font-family: \"Rigidica Text Bold\", sans-serif;\n    color: #333;\n    margin-bottom: 20px;\n    font-size: 20px;\n    padding-bottom: 10px;\n    border-bottom: 1px solid #eee;\n}\n\nh3 {\n    font-family: \"Rigidica Text Bold\", sans-serif;\n    color: #444;\n    margin: 20px 0 10px;\n    font-size: 18px;\n}\n\n.order-info {\n    background-color:\n        #f9f9f9;\n    padding: 15px;\n    border-radius: 6px;\n    margin-bottom: 20px;\n}\n\n.order-info-item {\n    display: flex;\n    justify-content: space-between;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    margin-bottom: 8px;\n    color: #555;\n}\n\n.order-info-item:last-child {\n    margin-bottom: 0;\n}\n\n.shipping-address {\n    background-color:\n        #f9f9f9;\n    padding: 15px;\n    border-radius: 6px;\n}\n\n.shipping-address p {\n    margin: 5px 0;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    color: #555;\n}\n\n.order-items-container {\n    margin-bottom: 20px;\n}\n\n.order-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 15px;\n    border-bottom: 1px solid #eee;\n}\n\n.order-item:last-child {\n    border-bottom: none;\n}\n\n.item-details {\n    display: flex;\n    flex-direction: column;\n}\n\n.item-name {\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    font-weight: 500;\n    color: #333;\n    margin-bottom: 5px;\n}\n\n.item-quantity {\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    color: #666;\n    font-size: 14px;\n}\n\n.item-price {\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    font-weight: 500;\n    color: #333;\n    min-width: 80px;\n    text-align: right;\n}\n\n.order-summary {\n    background-color:\n        #f9f9f9;\n    padding: 15px;\n    border-radius: 6px;\n}\n\n.order-summary-item {\n    display: flex;\n    justify-content: space-between;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    color: #555;\n    margin-bottom: 8px;\n}\n\n.order-summary-item.total {\n    font-weight: bold;\n    padding-top: 8px;\n    margin-top: 8px;\n    border-top: 1px solid #ddd;\n    color: #333;\n}\n\n.back-to-home {\n    display: block;\n    text-align: center;\n    margin-top: 30px;\n    padding: 10px;\n    background-color: #333;\n    color: white;\n    text-decoration: none;\n    border-radius: 4px;\n    transition: background-color 0.3s;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    font-size: 16px;\n}\n\n.back-to-home:hover {\n    background-color: #555;\n}\n\n.order-container.error,\n.order-container.loading {\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    text-align: center;\n    padding: 60px 20px;\n}\n\n.order-container.error h1 {\n    color:\n        #d9534f;\n    margin-bottom: 20px;\n}\n\n.order-container.loading h1 {\n    color: #333;\n    margin-bottom: 20px;\n}\n\n.loading-container {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: rgba(255, 255, 255, 0.8);\n    z-index: 1;\n}\n\n.loading-box {\n    text-align: center;\n    font-size: 24px;\n    color: #333;\n    font-family: \"Rigidica Text Light\", sans-serif;\n    padding: 20px 40px;\n    background-color: white;\n    border-radius: 8px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.loading-text {\n    font-size: 20px;\n}\n\n/* Guest Order Form Styling */\n.guest-form {\n    max-width: 500px;\n    margin: 0 auto;\n}\n\n.guest-form h1 {\n    font-family: \"Rigidica Text Bold\", sans-serif;\n    color: #333;\n    text-align: center;\n    margin-bottom: 15px;\n}\n\n.guest-form p {\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    color: #555;\n    text-align: center;\n    margin-bottom: 20px;\n}\n\n.guest-order-form {\n    width: 100%;\n    margin-bottom: 20px;\n}\n\n.form-error {\n    color:\n        #ff0000;\n    margin-bottom: 15px;\n    text-align: center;\n    font-size: 14px;\n    font-family: \"Rigidica Text Light\", sans-serif;\n}\n\n.form-group {\n    margin-bottom: 15px;\n}\n\n.form-group label {\n    display: block;\n    margin-bottom: 5px;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    color: #555;\n}\n\n.form-group input {\n    width: 100%;\n    padding: 10px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    outline: none;\n}\n\n.submit-button {\n    width: 100%;\n    background-color: #333;\n    color: #fff;\n    padding: 15px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    font-size: 16px;\n    transition: background-color 0.3s;\n}\n\n.submit-button:hover {\n    background-color: #555;\n}\n\n.order-login-suggestion {\n    text-align: center;\n    margin-top: 15px;\n    font-size: 14px;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    color: #000 !important;\n}\n\n.order-login-suggestion a {\n    color: #333;\n    text-decoration: none;\n}\n\n.order-login-suggestion a:hover {\n    text-decoration: underline;\n}\n\n/* CSS Media Queries */\n\n@media (max-width: 599px) {\n    .order-page {\n        padding-top: 40px;\n        padding-bottom: 20px;\n    }\n\n    .order-container {\n        padding: 15px;\n    }\n\n    .order-title {\n        font-size: 1.5rem;\n        margin-bottom: 12px;\n    }\n\n    .order-number {\n        font-size: 14px;\n        margin-bottom: 20px;\n    }\n\n    .order-content {\n        gap: 20px;\n    }\n\n    h2 {\n        font-size: 18px;\n        margin-bottom: 15px;\n    }\n\n    h3 {\n        font-size: 16px;\n    }\n\n    .guest-form h1 {\n        font-size: 1.5rem;\n    }\n\n    .guest-form p {\n        font-size: 14px;\n    }\n\n    .form-group input {\n        padding: 8px;\n    }\n\n    .submit-button {\n        font-size: 15px;\n    }\n\n    .back-to-home {\n        font-size: 14px;\n    }\n\n    .order-login-suggestion {\n        font-size: 13px !important;\n    }\n}\n\n@media (min-width: 600px) and (max-width: 767px) {\n    .order-page {\n        padding-top: 40px;\n    }\n\n    .order-container {\n        padding: 20px;\n    }\n\n    .order-title {\n        font-size: 1.6rem;\n    }\n\n    .order-content {\n        gap: 25px;\n    }\n\n    .guest-form {\n        max-width: 350px;\n    }\n}\n\n@media (min-width: 768px) and (max-width: 1023px) {\n    .order-page {\n        padding-top: 50px;\n    }\n\n    .order-container {\n        padding: 25px;\n    }\n\n    .order-title {\n        font-size: 1.7rem;\n        margin-bottom: 18px;\n    }\n\n    .order-content {\n        gap: 25px;\n    }\n\n    .guest-form {\n        max-width: 380px;\n    }\n\n    .submit-button {\n        font-size: 16px;\n    }\n}\n\n@media (min-width: 1024px) and (max-width: 1279px) {\n    .order-page {\n        padding-top: 60px;\n    }\n\n    .order-content {\n        gap: 30px;\n    }\n\n    .order-title {\n        font-size: 1.8rem;\n        margin-bottom: 20px;\n    }\n\n    .guest-form {\n        max-width: 400px;\n    }\n\n    .submit-button {\n        font-size: 16px;\n    }\n\n    .form-group {\n        margin-bottom: 18px;\n    }\n}\n\n@media (min-width: 1280px) and (max-width: 1439px) {\n    .order-page {\n        padding-top: 70px;\n    }\n\n    .order-title {\n        font-size: 1.9rem;\n        margin-bottom: 22px;\n    }\n\n    .guest-form {\n        max-width: 420px;\n    }\n\n    .form-group {\n        margin-bottom: 20px;\n    }\n\n    .form-group input {\n        padding: 11px;\n    }\n\n    .submit-button {\n        font-size: 17px;\n    }\n}\n\n@media (min-width: 1440px) and (max-width: 1535px) {\n    .order-page {\n        padding-top: 80px;\n    }\n\n    .order-title {\n        font-size: 2rem;\n        margin-bottom: 24px;\n    }\n\n    .guest-form {\n        max-width: 440px;\n    }\n\n    .form-group {\n        margin-bottom: 22px;\n    }\n\n    .form-group input {\n        padding: 12px;\n    }\n\n    .submit-button {\n        font-size: 17px;\n    }\n\n    .form-error {\n        font-size: 15px;\n    }\n\n    .order-login-suggestion {\n        font-size: 15px !important;\n    }\n}\n\n@media (min-width: 1536px) and (max-width: 1919px) {\n    .order-page {\n        padding-top: 90px;\n    }\n\n    .order-title {\n        font-size: 2.1rem;\n        margin-bottom: 26px;\n    }\n\n    .guest-form {\n        max-width: 460px;\n    }\n\n    .form-group {\n        margin-bottom: 24px;\n    }\n\n    .form-group input {\n        padding: 13px;\n        font-size: 16px;\n    }\n\n    .submit-button {\n        font-size: 18px;\n    }\n\n    .order-login-suggestion {\n        font-size: 16px !important;\n    }\n}\n\n@media (min-width: 1920px) and (max-width: 2559px) {\n    .order-page {\n        padding-top: 40px;\n    }\n\n    .order-container {\n        padding: 35px;\n    }\n\n    .order-title {\n        font-size: 2.3rem;\n        margin-bottom: 30px;\n    }\n\n    .guest-form {\n        max-width: 500px;\n    }\n\n    .guest-form h1 {\n        font-size: 2.2rem;\n        margin-bottom: 20px;\n    }\n\n    .guest-form p {\n        font-size: 18px;\n        margin-bottom: 25px;\n    }\n\n    .form-group {\n        margin-bottom: 26px;\n    }\n\n    .form-group label {\n        font-size: 16px;\n        margin-bottom: 8px;\n    }\n\n    .form-group input {\n        padding: 14px;\n        font-size: 16px;\n        border-radius: 6px;\n    }\n\n    .submit-button {\n        font-size: 19px;\n        border-radius: 6px;\n    }\n\n    .back-to-home {\n        font-size: 18px;\n        margin-top: 40px;\n    }\n\n    .order-login-suggestion {\n        font-size: 17px !important;\n    }\n}\n\n@media (min-width: 2560px) {\n    .order-page {\n        padding-top: 120px;\n    }\n\n    .order-container {\n        padding: 40px;\n        border-radius: 10px;\n    }\n\n    .order-title {\n        font-size: 2.5rem;\n        margin-bottom: 35px;\n    }\n\n    .order-number {\n        font-size: 18px;\n        margin-bottom: 40px;\n    }\n\n    .order-content {\n        gap: 40px;\n    }\n\n    h2 {\n        font-size: 24px;\n        margin-bottom: 25px;\n    }\n\n    h3 {\n        font-size: 22px;\n        margin: 25px 0 15px;\n    }\n\n    .guest-form {\n        max-width: 550px;\n    }\n\n    .guest-form h1 {\n        font-size: 2.5rem;\n        margin-bottom: 25px;\n    }\n\n    .guest-form p {\n        font-size: 20px;\n        margin-bottom: 30px;\n    }\n\n    .form-group {\n        margin-bottom: 30px;\n    }\n\n    .form-group label {\n        font-size: 18px;\n        margin-bottom: 10px;\n    }\n\n    .form-group input {\n        padding: 16px;\n        font-size: 18px;\n        border-radius: 8px;\n    }\n\n    .submit-button {\n        font-size: 20px;\n        border-radius: 8px;\n    }\n\n    .back-to-home {\n        font-size: 20px;\n        margin-top: 50px;\n        border-radius: 8px;\n    }\n\n    .form-error {\n        font-size: 16px;\n        margin-bottom: 20px;\n    }\n\n    .order-login-suggestion {\n        font-size: 18px !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
